import { fitText } from "../utils/textFitUtils";
import Confetti from "react-confetti";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import makinItRain from "../images/makin_it_rain.png";
import QuagganEmoji from "./QuagganEmoji.jsx";

// TODO: add toggle for confetti in settings or temp. hide button
// TODO: make confetti intensity adjustable in settings, test max performance impact

const confettiIntensity = 200;

function WinnerMenu({
  winner,
  winnerIconSrc,
  winnerEmojiSeed,
  showQuagganEmojis,
  winnerInNames,
  winnerNameRemovedFromList,
  onClose,
  onSpinAgain,
  onAddWinner,
  onRemoveWinner,
  onAddWinnerBack,
  onOpenPublishWindow,
  visible,
  muted,
}) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (visible) {
      document.body.style.overflowX = "hidden";
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play();
      }
    } else {
      document.body.style.overflowX = "";
    }
    return () => {
      document.body.style.overflowX = "";
    };
  }, [visible]);

  const { display, fontSize } = fitText({
    text: winner,
    maxFontSize: 32,
    minFontSize: 14,
    maxWidth: winnerIconSrc || showQuagganEmojis ? 182 : 240,
    maxLength: 18,
    fontScale: 0.6,
  });

  if (!visible) return null;

  const btnStyle = {
    margin: "6px 0",
    fontSize: 16,
    fontWeight: "700",
    letterSpacing: "0.06em",
    padding: "12px 32px",
    borderRadius: "50px",
    border: "1px solid rgba(80, 180, 255, 0.45)",
    background:
      "linear-gradient(135deg, rgba(20, 70, 140, 0.85) 0%, rgba(10, 40, 90, 0.9) 100%)",
    color: "#d0f0ff",
    cursor: "pointer",
    backdropFilter: "blur(8px)",
    boxShadow: "0 0 16px rgba(0, 150, 255, 0.2), 0 4px 10px rgba(0,0,0,0.3)",
    transition: "all 0.2s ease",
    width: "100%",
  };
  const disabledBtnStyle = {
    ...btnStyle,
    background: "rgba(20, 45, 80, 0.45)",
    border: "1px solid rgba(80, 140, 200, 0.3)",
    color: "rgba(170, 210, 240, 0.6)",
    boxShadow: "0 0 8px rgba(0, 120, 180, 0.1), 0 2px 6px rgba(0,0,0,0.2)",
    cursor: "not-allowed",
  };

  const winnerAlreadyRemoved = Boolean(winnerNameRemovedFromList);
  const removeActionsDisabled = winnerAlreadyRemoved || !winnerInNames;
  const removeDisabledTitle = winnerAlreadyRemoved
    ? "Name already removed"
    : "Name already removed";
  const addBackDisabled = winnerInNames;
  const addBackTitle = addBackDisabled
    ? "Name already on list"
    : "Add winner name back to list";

  const btnHover = (e) => {
    if (e.currentTarget.disabled) return;
    e.currentTarget.style.boxShadow =
      "0 0 28px rgba(0, 180, 255, 0.45), 0 4px 14px rgba(0,0,0,0.4)";
    e.currentTarget.style.borderColor = "rgba(100, 200, 255, 0.7)";
    e.currentTarget.style.color = "#ffffff";
    e.currentTarget.style.transform = "translateY(-2px)";
  };
  const btnLeave = (e) => {
    if (e.currentTarget.disabled) return;
    e.currentTarget.style.boxShadow =
      "0 0 16px rgba(0, 150, 255, 0.2), 0 4px 10px rgba(0,0,0,0.3)";
    e.currentTarget.style.borderColor = "rgba(80, 180, 255, 0.45)";
    e.currentTarget.style.color = "#d0f0ff";
    e.currentTarget.style.transform = "translateY(0)";
  };

  const shouldShowQuagganEmoji = Boolean(showQuagganEmojis) && !winnerIconSrc;
  const publishButtonStyle = {
    position: "absolute",
    right: 18,
    bottom: 18,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
    zIndex: 3,
  };

    return createPortal(
      <div className="panel winner-menu">
      {/* Winner sound */}
      <audio
        ref={audioRef}
        src={require("../sounds/nice teeth.ogg")}
        muted={muted}
      />

      {/* Full-screen dim background behind items & winner menu */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(2, 10, 30, 0.75)",
          backdropFilter: "blur(4px)",
          zIndex: 1001,
        }}
        onClick={onClose}
      />

      {/* Confetti above overlay, below modal */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: "none",
          zIndex: 1004,
        }}
      >
        {" "}
        <Confetti
          style={{ width: "100%", height: "100%" }}
          recycle={true}
          numberOfPieces={confettiIntensity}
          colors={[
            "#40c8ff",
            "#a0e8ff",
            "#ffffff",
            "#ffd966",
            "#80ffcc",
            "#c084fc",
          ]}
        />
      </div>

      {/* Modal container: let clicks pass through outside card */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1003,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          overflow: "hidden",
          paddingTop: 24,
          paddingBottom: 24,
          pointerEvents: "none",
        }}
      >
        <div
          data-publish-snapshot-root="winner-menu"
          style={{
            position: "relative",
            border: "1px solid rgba(80, 180, 255, 0.4)",
            borderRadius: 24,
            boxShadow:
              "0 0 60px rgba(0, 150, 255, 0.25), 0 8px 32px rgba(0, 0, 0, 0.6)",
            padding: "36px 36px 0 36px",
            maxWidth: "90vw",
            width: 420,
            boxSizing: "border-box",
            textAlign: "center",
            overflow: "hidden",
            minHeight: "min(750px, calc(100vh - 48px))",
            maxHeight: "calc(100vh - 48px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            background:
              "linear-gradient(160deg, rgba(10, 35, 70, 0.97) 0%, rgba(5, 20, 50, 0.98) 100%)",
            backdropFilter: "blur(16px)",
            pointerEvents: "auto",
            transform: "translateY(-8px)",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Subtle top glow */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: 2,
              background:
                "linear-gradient(90deg, transparent, rgba(100, 200, 255, 0.6), transparent)",
              borderRadius: "24px 24px 0 0",
            }}
          />

          {/* Quaggan image — bottom of modal */}
          <img
            src={makinItRain}
            alt="Makin it rain"
            style={{
              position: "absolute",
              left: 0,
              bottom: 0,
              width: "100%",
              height: "auto",
              pointerEvents: "none",
              zIndex: 1,
              opacity: 0.9,
            }}
          />

          {/* Modal content */}
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              zIndex: 2,
            }}
          >
            {/* Title */}
            <h2
              style={{
                marginTop: 0,
                marginBottom: 8,
                fontSize: 28,
                fontWeight: "800",
                letterSpacing: "0.05em",
                color: "#40e8ff",
                textShadow: "0 0 20px rgba(60, 200, 255, 0.6)",
              }}
            >
              Winner!
            </h2>

            {/* Divider */}
            <div
              style={{
                width: "60%",
                height: 1,
                background:
                  "linear-gradient(90deg, transparent, rgba(80, 180, 255, 0.4), transparent)",
                marginBottom: 16,
              }}
            />

            {/* Winner name */}
            <div
              style={{
                fontSize,
                color: "#ffffff",
                fontWeight: "bold",
                margin: "8px 0 24px 0",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                height: 48,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                background: "rgba(20, 70, 140, 0.5)",
                border: "1px solid rgba(120, 180, 255, 0.4)",
                borderRadius: 12,
                padding: "0 24px",
                width: "100%",
                boxSizing: "border-box",
                boxShadow: "inset 0 1px 0 rgba(180, 235, 255, 0.1)",
              }}
            >
              {winnerIconSrc ? (
                <img
                  src={winnerIconSrc}
                  alt={`${display} icon`}
                  style={{
                    width: 28,
                    height: 28,
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
              ) : shouldShowQuagganEmoji ? (
                <QuagganEmoji
                  type="all"
                  seed={winnerEmojiSeed || winner}
                  inline
                  size={28}
                  style={{ margin: 0, flexShrink: 0 }}
                />
              ) : null}
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {display}
              </span>
            </div>
            {/* Buttons */}
            <button
              style={btnStyle}
              onMouseEnter={btnHover}
              onMouseLeave={btnLeave}
              onClick={onSpinAgain}
            >
              Spin again
            </button>
            <button
              style={btnStyle}
              onMouseEnter={btnHover}
              onMouseLeave={btnLeave}
              title={
                removeActionsDisabled
                  ? "Name already removed from list. This only adds to winners now"
                  : "Add winner and remove the name from list"
              }
              onClick={onAddWinner}
            >
              Add name to winners
            </button>
            <button
              style={removeActionsDisabled ? disabledBtnStyle : btnStyle}
              onMouseEnter={btnHover}
              onMouseLeave={btnLeave}
              title={removeActionsDisabled ? removeDisabledTitle : "Remove winner name from list"}
              onClick={onRemoveWinner}
              disabled={removeActionsDisabled}
            >
              Remove name from list
            </button>
            <button
              style={addBackDisabled ? disabledBtnStyle : btnStyle}
              onMouseEnter={btnHover}
              onMouseLeave={btnLeave}
              title={addBackTitle}
              onClick={onAddWinnerBack}
              disabled={addBackDisabled}
            >
              Add name to list again
            </button>
            <button
              style={{
                ...btnStyle,
                background: "rgba(10, 25, 50, 0.6)",
                color: "rgba(160, 210, 255, 0.6)",
                border: "1px solid rgba(80, 140, 200, 0.25)",
                marginTop: 4,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#a0d0ff";
                e.currentTarget.style.borderColor = "rgba(80, 180, 255, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "rgba(160, 210, 255, 0.6)";
                e.currentTarget.style.borderColor = "rgba(80, 140, 200, 0.25)";
              }}
              onClick={onClose}
            >
              Close
            </button>
          </div>

          <div style={publishButtonStyle} className="publish-button-container">
            <div
              style={{
                color: "rgba(170, 230, 255, 0.92)",
                fontSize: 12,
                fontWeight: 800,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                textShadow: "0 0 10px rgba(64, 200, 255, 0.35)",
                marginBottom: 4,
              }}
            >
              Publish
            </div>
            <button
              type="button"
              onClick={onOpenPublishWindow}
              title="Publish winner to Discord"
              aria-label="Publish winner to Discord"
              style={{
                width: 56,
                height: 56,
                borderRadius: 16,
                border: "1px solid rgba(120, 220, 255, 0.45)",
                background:
                  "linear-gradient(145deg, rgba(9, 44, 82, 0.96), rgba(3, 20, 40, 0.98))",
                color: "#bfefff",
                cursor: "pointer",
                boxShadow:
                  "0 8px 20px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(180, 235, 255, 0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
                transition: "transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.borderColor = "rgba(160, 235, 255, 0.75)";
                e.currentTarget.style.boxShadow =
                  "0 10px 22px rgba(0, 0, 0, 0.42), 0 0 18px rgba(64, 200, 255, 0.22), inset 0 1px 0 rgba(180, 235, 255, 0.18)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.borderColor = "rgba(120, 220, 255, 0.45)";
                e.currentTarget.style.boxShadow =
                  "0 8px 20px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(180, 235, 255, 0.12)";
              }}
            >
              <svg
                viewBox="0 0 24 24"
                width="28"
                height="28"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.9"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M6 9l6-6 6 6" />
                <path d="M12 3v12" />
                <path d="M4 15h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Background confetti layer */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: "none",
          zIndex: 1000,
        }}
      >
        <Confetti
          style={{ width: "100%", height: "100%" }}
          recycle={true}
          numberOfPieces={confettiIntensity}
          colors={[
            "#40c8ff",
            "#a0e8ff",
            "#ffffff",
            "#ffd966",
            "#80ffcc",
            "#c084fc",
          ]}
        />
      </div>
    </div>,
    document.body
  );
}

export default WinnerMenu;
